import React, { Fragment } from "react";
import { capitalizeFirstLetter } from "../../../../utils/Functions";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Box, Checkbox, TextField, Typography } from "@mui/material";

const formFields = ["oib", "personToContact"];
const formIsRequiredFields = [false, true];

export default function OrganizationInfo() {
  const { register, formState, watch } = useFormContext();
  const { errors } = formState;
  const isShelterChecked = watch("shelter", false); // Default value if undefined
  const { t } = useTranslation();

  return (
    <Fragment>
      {formFields.map((field, index) => (
        <TextField
          key={index}
          required={formIsRequiredFields[index]}
          fullWidth
          name={field.title}
          size="medium"
          label={t(capitalizeFirstLetter(field))}
          error={!!errors?.[field]}
          helperText={errors?.[field]?.message}
          inputProps={{ "data-testid": `auth.signup.${field}-input` }}
          {...register(field)}
        />
      ))}
      <Box
        display={"flex"}
        width={"100%"}
        flexDirection={"row"}
        p={1}
        borderRadius={1}
        border={"1px solid GrayText"}
        color={"GrayText"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Typography>{t("isShelter")}</Typography>
        <Checkbox
          {...register("shelter")}
          key={"shelter-checkbox-key"}
          checked={isShelterChecked}
          inputProps={{ "data-testid": "auth.signup.shelter-checkbox" }}
        />
      </Box>
    </Fragment>
  );
}
